import axios from "../../axios/index.js"



export default {
    UpdateProfileAccount(nom, prenom,email,id) {
    return axios.post("clients/"+id,{nom: nom, prenom: prenom, email: email},{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  UpdateProfileInformation(payload) {
    return axios.post("clients/info/"+payload.id,payload.DataBody,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  UpdateProfileSocial(payload) {
    return axios.post("clients/social/"+payload.id,payload.DataBody ,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  UpdateProfileConfide(payload) {
     
    return axios.post("comptes/updateconfid/"+payload.DataBody.oldusername,payload.DataBody,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}} )
  },
  GetLocations() {
    return axios.get("localisations" )
  },
  UpdateSociete(payload) {
    
    return axios.post("societes/"+payload.id,payload.DataBody,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  GetImage(payload) {
    
    return axios.get('clients/photouser/'+payload.id,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  UpdateImage(payload) {
    return axios.post("clients/updatephoto/"+payload.id,payload.formData,{ headers: {'Content-Type': 'multipart/form-data',Authorization: 'Bearer '+localStorage.getItem('accessToken')}, })
  },
}
